import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useBookingForm } from "./useBookingForm";
import { format } from "date-fns";

import axios from "axios";
import { isValidPhoneNumber } from "react-phone-number-input";

import PhoneInput from "react-phone-number-input";
import { Button } from "react-bootstrap";

import SimpleBookingForm from "./SimpleBookingForm";
import { ManagerBookingRequest } from "./NewBookingManager";
import { toDateOnlyString, toDisplayDate } from "../../Utilities/date";

interface NewBookingFormProps {
  booking: any;
  setBooking: React.Dispatch<React.SetStateAction<any>>;
  handleAddBooking: (booking: any) => void;
  handleUpdateBooking: (booking: any) => void;
  handleEditBooking: (booking: any) => void;
  onSubmit: () => void;
  onCancel: () => void;
  onEdit?: () => void;
  onClose?: () => void;
  dateRange: { startDate: Date | null; endDate: Date | null };
  setDateRange: React.Dispatch<
    React.SetStateAction<{ startDate: Date | null; endDate: Date | null }>
  >;
  formVisible: boolean;
  setFormVisible: (visible: boolean) => void;
}

const NewBookingForm: React.FC<NewBookingFormProps> = ({
  booking,
  setBooking,
  handleAddBooking,
  handleUpdateBooking,
  onSubmit,
  onCancel,
  onEdit,
  dateRange,
  setDateRange,
  formVisible,
  setFormVisible,
}) => {
  const location = useLocation();

  const [localEmail, setLocalEmail] = useState<string>("");
  const [submitError, setSubmitError] = useState<string>("");
  const apiUrl = process.env.REACT_APP_API_URL;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [packageId, setPackageId] = useState<number | null>(null);
  const [packageSelected, setPackageSelected] = useState<boolean>(false);
  const [phoneNumberError, setPhoneNumberError] = useState<string>("");
  const [emailError, setEmailError] = useState<string>("");
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [defaultCountry, setDefaultCountry] = useState<string>("US");
  const [userType, setUserType] = useState<"private" | "business">("private");
  // Business bookings are saved by the backend at 20% off the gross package
  // price (BookingService.cs: `totalPrice *= 0.8m` for IsBusinessUser). Show
  // that same net price here so staff never see/quote a number that differs
  // from what actually gets saved/invoiced.
  const BUSINESS_DISCOUNT_MULTIPLIER = 0.8;
  const getDisplayPrice = (price: number) =>
    userType === "business" ? price * BUSINESS_DISCOUNT_MULTIPLIER : price;
  // Prevents duplicate bookings from double-clicking "Confirm Bookings" while a slow request is in flight.
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [businessCode, setBusinessCode] = useState<string>("");
  const [userFound, setUserFound] = useState<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedAvailability, setSelectedAvailability] = useState<
    number | null
  >(null);
  const [businessUser, setBusinessUser] = useState({
    email: "",
    customerName: "",
    name: "",
    address: "",
    address2: "",
    zipCode: "",
    city: "",
    country: "",
    phoneNumber: "",
    businessCode: "",
    arrivalDate: "",
    departureDate: "",
    isBusinessUser: true,
  });
  const [privateUser, setPrivateUser] = useState({
    email: "",
    customerName: "",
    name: "",
    address: "",
    address2: "",
    zipCode: "",
    city: "",
    country: "",
    phoneNumber: "",
    businessCode: "",
    arrivalDate: "",
    departureDate: "",
    paymentIntentId: "",
    customerId: "",
  });
  const [businessCodeValidated, setBusinessCodeValidated] = useState(false);

  const {
    availability,

    selectedPackages,
    totalCost,

    handleCheckAvailability,
    handleSelectPackage,
  } = useBookingForm(dateRange);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [availablePackages, setAvailablePackages] = useState<any[]>([]); // State to hold available packages
  const [shoppingCart, setShoppingCart] = useState<ManagerBookingRequest[]>([]);
  const [selectedAvailabilities, setSelectedAvailabilities] = useState<
    number[]
  >([]);

  useEffect(() => {
    // Fetch available packages when the component mounts
    const fetchPackages = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/Package/getAllPackages`
        );
        setAvailablePackages(response.data as any[]);
      } catch (error) {
        console.error("Error fetching packages", error);
      }
    };

    fetchPackages();
  }, []);

  useEffect(() => {
    if (location.state && location.state.dateRange) {
      setDateRange(location.state.dateRange);
      const packageId = location.state.packageId || null;
      if (packageId) {
        handleCheckAvailability(packageId);
      }
    }
  }, [location.state, setDateRange, handleCheckAvailability]);

  useEffect(() => {
    if (selectedPackages.length > 0) {
      setPackageSelected(true);
    } else {
      setPackageSelected(false);
    }
  }, [selectedPackages]);

  useEffect(() => {
    console.log("form visible:", formVisible);
  }, [formVisible]);

  const validatePhoneNumber = (phoneNumber: string) => {
    if (!phoneNumber || !isValidPhoneNumber(phoneNumber)) {
      setPhoneNumberError("Please enter a valid phone number.");
    } else {
      setPhoneNumberError("");
      if (userType === "business") {
        setBusinessUser((prevBusinessUser) => ({
          ...prevBusinessUser,
          phoneNumber,
        }));
      } else {
        setPrivateUser((prevPrivateUser) => ({
          ...prevPrivateUser,
          phoneNumber,
        }));
      }
    }
  };

  const handlePhoneNumberChange = (phoneNumber: string) => {
    validatePhoneNumber(phoneNumber);
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError("Please enter a valid email address.");
    } else {
      setEmailError("");
      if (userType === "business") {
        setBusinessUser((prevBusinessUser) => ({ ...prevBusinessUser, email }));
      } else {
        setPrivateUser((prevPrivateUser) => ({ ...prevPrivateUser, email }));
      }
    }
  };

  const handleUserSearch = async () => {
    var token = localStorage.getItem("token");
    var apiUrl = process.env.REACT_APP_API_URL;

    try {
      const response = await axios.get(
        `${apiUrl}/Booking/searchUser/${localEmail}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = response.data as { message: string; data?: any };
      if (
        responseData.message ===
        "Private user not found. You can add a new private user."
      ) {
        setFormVisible(true);
        setUserType("private");
        setPrivateUser({
          ...privateUser,
          email: localEmail,
        });
        setUserFound(false);
        setEmailError(""); // Clear the error message
      } else if ((response.data as { data?: any }).data) {
        const user = (response.data as { data: any }).data;
        setFormVisible(true);
        setUserType(user.isBusinessUser ? "business" : "private");
        if (user.isBusinessUser) {
          setBusinessUser(user);
          setBusinessCodeValidated(true);
        } else {
          setPrivateUser(user);
        }
        setUserFound(true);
        setEmailError(""); // Clear the error message
      } else {
        setEmailError("User not found.");
        setUserFound(false);
      }
    } catch (error) {
      console.error("Error searching user", error);
      setEmailError("Error searching user.");
      setUserFound(false);
    }
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleDateChange = (update: [Date | null, Date | null]) => {
    let [start, end] = update;
    if (start && !end) {
      const defaultEnd = new Date(start);
      defaultEnd.setDate(defaultEnd.getDate() + 7);
      end = defaultEnd;
    }

    setDateRange({ startDate: start, endDate: end });

    const formattedArrivalDate = start
      ? format(start, "yyyy-MM-dd'T'HH:mm:ssXXX")
      : "";
    const formattedDepartureDate = end
      ? format(end, "yyyy-MM-dd'T'HH:mm:ssXXX")
      : "";

    if (userType === "business") {
      setBusinessUser((prevBusinessUser) => ({
        ...prevBusinessUser,
        arrivalDate: formattedArrivalDate,
        departureDate: formattedDepartureDate,
      }));
      console.log("Updated Business User:", {
        ...businessUser,
        arrivalDate: formattedArrivalDate,
        departureDate: formattedDepartureDate,
      }); // Log the updated business user data
    } else {
      setPrivateUser((prevPrivateUser) => ({
        ...prevPrivateUser,
        arrivalDate: formattedArrivalDate,
        departureDate: formattedDepartureDate,
      }));
      console.log("Updated Private User:", {
        ...privateUser,
        arrivalDate: formattedArrivalDate,
        departureDate: formattedDepartureDate,
      }); // Log the updated private user data
    }
  };

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;

    if (userType === "business") {
      setBusinessUser((prevBusinessUser) => ({
        ...prevBusinessUser,
        [name]: value,
      }));
    } else {
      setPrivateUser((prevPrivateUser) => ({
        ...prevPrivateUser,
        [name]: value,
      }));
    }
  };

  const handleBusinessCodeChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const code = event.target.value;
    setBusinessCode(code);
    console.log("Business code:", code);

    if (code) {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/BusinessUser/getBusinessUserByCode?businessCode=${code}`
        );
        const businessDetails = response.data as {
          email: string;
          name: string;
          address: string;
          address2?: string;
          zipCode: string;
          city: string;
          country: string;
          phoneNumber: string;
        };

        setBusinessUser({
          email: businessDetails.email,
          customerName: businessDetails.name,
          name: businessDetails.name,
          address: businessDetails.address,
          address2: businessDetails.address2 || "",
          zipCode: businessDetails.zipCode,
          city: businessDetails.city,
          country: businessDetails.country,
          phoneNumber: businessDetails.phoneNumber,
          arrivalDate: dateRange.startDate?.toISOString() || "",
          departureDate: dateRange.endDate?.toISOString() || "",
          businessCode: code,
          isBusinessUser: true,
        });
        setBusinessCodeValidated(true);
        console.log("Business details:", businessDetails);
      } catch (error) {
        console.error("Error fetching business details", error);
        setBusinessCodeValidated(false);
      }
    } else {
      setBusinessCodeValidated(false);
    }
  };

  useEffect(() => {
    console.log("business code validated:", businessCodeValidated);
  }, [businessCodeValidated]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const checkPrivateUserExists = async (email: string) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/PrivateUser/checkUserByEmail/${email}`
      );
      return (response.data as { data: any }).data; // Return the user data if exists
    } catch (error) {
      console.error("Error checking private user existence", error);
      return null;
    }
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const addPrivateUser = async (userInfoPayload: any) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/PrivateUser/userInfo`,
        userInfoPayload
      );
      console.log("User info submitted:", response);
      return response.data;
    } catch (error) {
      console.error("Error adding private user", error);
      throw error;
    }
  };

  const addToCart = () => {
    if (!localEmail || !userFound) {
      setEmailError(
        "Please search and select a customer before adding to cart."
      );
      return;
    }

    const sessionId = localStorage.getItem("sessionId");
    if (!sessionId) {
      console.error("SessionId is not found in localStorage");
      return;
    }

    const newBookings = selectedAvailabilities
      .map((index) => {
        if (!availability) {
          console.error("Availability is null");
          return undefined;
        }
        const selectedAvailability = availability[index];
        const booking: ManagerBookingRequest = {
          PackageId: packageId,
          PricingModelId: selectedAvailability.pricingModelId,
          ArrivalDate: toDateOnlyString(dateRange.startDate),
          DepartureDate: toDateOnlyString(dateRange.endDate),
          NumberOfPersons: 1,
          //    NumberOfPersons: 1, // Assuming a default value, adjust as needed
          IsBusinessUser: userType === "business",
          Email: localEmail,
          CustomerName:
            userType === "business" ? businessUser.name : privateUser.name,
          PhoneNumber:
            userType === "business"
              ? businessUser.phoneNumber
              : privateUser.phoneNumber,
          Address:
            userType === "business"
              ? businessUser.address
              : privateUser.address,
          City: userType === "business" ? businessUser.city : privateUser.city,
          State: "", // Add state if applicable
          ZipCode:
            userType === "business"
              ? businessUser.zipCode
              : privateUser.zipCode,
          Country:
            userType === "business"
              ? businessUser.country
              : privateUser.country,
          SessionId: sessionId,
          TotalPrice: getDisplayPrice(selectedAvailability.totalPrice),
          PricingModelDescription: selectedAvailability.pricingModelDescription,
          BookingDescription: "", // Add booking description if applicable
        };
        return booking;
      })
      .filter((booking): booking is ManagerBookingRequest => Boolean(booking));

  setShoppingCart([...shoppingCart, ...newBookings]);
  };

  const handleRemoveFromCart = (index: number) => {
    const updatedCart = shoppingCart.filter((_, i) => i !== index);
    setShoppingCart(updatedCart);
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault(); // Prevent default form submission
    if (isSubmitting) {
      return; // Guard against double-submission (e.g. double-click or slow connection)
    }
    console.log("Form Submitted");

    // Skip business code validation if the business user is pre-populated
    if (
      userType === "business" &&
      !businessCodeValidated &&
      !businessUser.businessCode
    ) {
      alert("Please enter a valid business code.");
      return;
    }

    console.log("Business User Before Submit:", businessUser); // Log the business user data before submit
    console.log("Private User Before Submit:", privateUser); // Log the private user data before submit

    const requests: ManagerBookingRequest[] = shoppingCart.map((item) => ({
      PackageId: item.PackageId,
      PricingModelId: item.PricingModelId,
      ArrivalDate: toDateOnlyString(item.ArrivalDate),
      DepartureDate: toDateOnlyString(item.DepartureDate),
      NumberOfPersons: item.NumberOfPersons,
      IsBusinessUser: item.IsBusinessUser,
      Email: item.Email,
      CustomerName: item.CustomerName,

      PhoneNumber: item.PhoneNumber,
      Address: item.Address,
      City: item.City,
      State: item.State,
      ZipCode: item.ZipCode,
      Country: item.Country,
      SessionId: item.SessionId,
      TotalPrice: item.TotalPrice,
      PricingModelDescription: item.PricingModelDescription,
      BookingDescription: item.BookingDescription,
    }));

    setIsSubmitting(true);
    try {
      const response = await axios.post(
        `${apiUrl}/Booking/BookPackageForManager`,
        requests
      );
      const responseData = response.data as {
        success: boolean;
        message?: string;
      };
      if (responseData.success) {
        alert("Booking confirmed");
        setSubmitError("");
      } else {
        const responseData = response.data as { message: string };
        setSubmitError(`Booking failed: ${responseData.message}`);
      }
    } catch (error: any) {
      console.error("Error booking package", error);
      console.error('Response status:', error?.response?.status);
      console.error('Response data:', JSON.stringify(error?.response?.data, null, 2));
      // Extract server-provided message with enhanced detail extraction
      const status = error?.response?.status;
      const data = error?.response?.data;
      
      // Build a detailed error message from various possible formats
      const extractErrorDetails = (): string => {
        if (!data) {
          return error?.message || 'Unknown error occurred';
        }
        
        // Handle plain string response
        if (typeof data === 'string') {
          return data;
        }
        
        const parts: string[] = [];
        
        // ASP.NET Core Problem Details format
        if (data.title) {
          parts.push(data.title);
        }
        if (data.detail) {
          parts.push(data.detail);
        }
        
        // Standard message field
        if (data.message && !parts.includes(data.message)) {
          parts.push(data.message);
        }
        
        // Validation errors object
        if (data.errors && typeof data.errors === 'object') {
          const errorMessages = Object.entries(data.errors)
            .map(([field, messages]) => {
              const msgs = Array.isArray(messages) ? messages.join(', ') : String(messages);
              return `${field}: ${msgs}`;
            })
            .join('; ');
          if (errorMessages) {
            parts.push(`Validation: ${errorMessages}`);
          }
        }
        
        // Inner exception details
        if (data.innerException) {
          parts.push(`Details: ${data.innerException}`);
        }
        
        if (parts.length === 0) {
          return error?.message || 'Booking failed - server returned an error';
        }
        
        return parts.join(' | ');
      };

      // Map backend messages to friendlier text
      // Only map "session expired" for actual 401 responses, not 500s that mention "unauthorized"
      const mapServerMessage = (msg: string, httpStatus?: number): string => {
        if (!msg) return '';
        const lower = msg.toLowerCase();
        if (lower.includes('no available chalets')) {
          return 'Those dates are fully booked for the selected option. Try different dates or choose another chalet type.';
        }
        if (lower.includes('not enough availability')) {
          return 'The group size exceeds the remaining availability for those dates.';
        }
        if (lower.includes('date range not found')) {
          return 'The selected package does not cover these dates. Pick dates within the package window.';
        }
        if (httpStatus === 401 || (httpStatus !== 500 && (lower.includes('unauthorized') || lower.includes('401')))) {
          return 'Your session has expired. Please log in again.';
        }
        return '';
      };

      const serverMessage = extractErrorDetails();
      const friendly = mapServerMessage(serverMessage, status);
      const dateHint = dateRange.startDate && dateRange.endDate
        ? ` (Selected dates: ${dateRange.startDate.toLocaleDateString()} – ${dateRange.endDate.toLocaleDateString()})`
        : '';
      
      const statusHint = status === 500
        ? ' This may be a temporary server issue. Try refreshing and submitting again.'
        : '';

      const composed = friendly
        ? `${friendly}${dateHint}${statusHint}`
        : serverMessage
          ? `${serverMessage}${dateHint}${statusHint}`
          : `Booking failed. Please review the dates and options.${statusHint}`;

      const withStatus = status ? `[Error ${status}] ${composed}` : composed;
      setSubmitError(withStatus);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCheckboxChange = (index: number) => {
    setSelectedAvailabilities((prevSelected) => {
      if (prevSelected.includes(index)) {
        return prevSelected.filter((i) => i !== index); // Deselect if already selected
      } else {
        return [...prevSelected, index]; // Select the new index
      }
    });
  };

  return (
    <>
      {/* <div className='booking-section'>
              
                <div className='booking-availability'>
                    <div className="avail-error">
                        {availabilityError && <div className='text-danger'>{availabilityError}</div>}
                    </div>
                    <div class="form-group">
                        <label htmlFor="package">Select Package</label>
                        <select
                            id="package"
                            name="package"
                            value={packageId ?? ''}
                            onChange={(e) => setPackageId(Number(e.target.value))}
                            className="form-control"
                        >
                            <option value="" disabled>Select a package</option>
                            {availablePackages.map(pkg => (
                                <option key={pkg.id} value={pkg.id}>{pkg.name}</option>
                            ))}
                        </select>
                    </div>
                    <div class="form-group">
                        <label htmlFor="dateRange">Arrival & Departure Dates</label>
                   
                        <div className="date-picker-wrapper">
                            <FontAwesomeIcon icon={faCalendarAlt} className="fa-calendar custom-calendar-icon" />
                            <DatePicker
                                selected={dateRange.startDate}
                                onChange={handleDateChange}
                                startDate={dateRange.startDate ?? undefined}
                                endDate={dateRange.endDate ?? undefined}
                                selectsRange
                                className="form-control"
                                placeholderText="Select dates"
                                dateFormat="EEE MMM d"
                                locale={locale}
                                calendarStartDay={1} // Start the calendar on Monday
                            />
                        </div>
                        <button type="button" className="btn btn-primary" onClick={() => packageId && handleCheckAvailability(packageId)}>
                            Check Availability
                        </button>
                    </div>
                </div>
            </div> */}

      <div className="container booking-section mb-2 pb-2">
        {availability && (
          <div className="booking mt-1">
            {/* <AvailabilityComponent  startDate={dateRange.startDate ? dateRange.startDate.toISOString() : ''} endDate={dateRange.endDate ? dateRange.endDate.toISOString() : ''} /> */}
            <SimpleBookingForm apiUrl={apiUrl || ""} />
            <h3>Available Cabins:</h3>
            <div className="container row align-items-center">
              {availability.map((site, index) => (
                <div className="col" key={index}>
                  <div className="card">
                    <div className="card-header">
                      <img
                        src={
                          site.imageUrls?.find((img: any) => img.isMain)?.url ||
                          "default-image-url.jpg"
                        }
                        className="card-img-top"
                        alt="Package"
                      />
                      <div>
                        <h5 className="card-title">{site.name}</h5>
                        <h6 className="card-subtitle mb-2 text-muted">
                          {site.location}
                        </h6>
                      </div>
                    </div>
                    <div className="card-body">
                      <p className="card-text">
                        Capacity: {site.capacity} <br />
                        Price per person: ${site.pricePerNight}
                      </p>

                      <div className="d-grid">
                        <Button
                          variant={
                            selectedPackages.some(
                              (pkg: any) => pkg.id === site.id
                            )
                              ? "danger"
                              : "success"
                          }
                          onClick={() => handleSelectPackage(site)}
                        >
                          {selectedPackages.some(
                            (pkg: any) => pkg.id === site.id
                          )
                            ? "Deselect"
                            : "Select"}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {packageSelected && (
        <div className="container d-flex justify-content-center">
          <div className="booking-details-section pb-5 mb-5">
            <h3>Booking Details</h3>
            <form onSubmit={handleSubmit}>
              <div className="form-group mb-5 pb-5">
                <label htmlFor="email">
                  Customer Email, Name, or Business Code
                </label>
                <input
                  type="text"
                  id="email"
                  name="email"
                  value={localEmail}
                  onChange={(e) => setLocalEmail(e.target.value)}
                  className="booking-form-control"
                />
                <button
                  type="button"
                  className="btn btn-primary mt-2 mb-5"
                  onClick={handleUserSearch}
                >
                  Search User
                </button>
                {emailError && <div className="text-danger">{emailError}</div>}
              </div>
              {formVisible && (
                <>
                  <div className="form-group">
                    <label htmlFor="userType">User Type</label>
                    <select
                      id="userType"
                      name="userType"
                      value={userType}
                      onChange={(e) =>
                        setUserType(e.target.value as "private" | "business")
                      }
                      className="booking-form-control"
                    >
                      <option value="private">Private</option>
                      {userFound && <option value="business">Business</option>}
                    </select>
                  </div>
                  {userType === "business" && (
                    <div className="form-group">
                      <label htmlFor="businessCode">Business Code</label>
                      <input
                        type="text"
                        id="businessCode"
                        name="businessCode"
                        value={businessUser?.businessCode}
                        onChange={handleBusinessCodeChange}
                        className="booking-form-control"
                        readOnly={businessCodeValidated}
                      />
                    </div>
                  )}
                  <div className="form-group">
                    <label htmlFor="phoneNumber">Phone Number</label>
                    <PhoneInput
                      id="phoneNumber"
                      name="phoneNumber"
                      value={
                        userType === "business"
                          ? businessUser.phoneNumber
                          : privateUser.phoneNumber
                      }
                      onChange={handlePhoneNumberChange as any}
                      defaultCountry={defaultCountry as any}
                    />
                    {phoneNumberError && (
                      <div className="text-danger">{phoneNumberError}</div>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="customerName">
                      {userType === "business" ? "Business Contact Name (from account) — add real Guest Names below" : "Customer Name"}
                    </label>
                    <input
                      type="text"
                      id="customerName"
                      name="customerName"
                      value={
                        userType === "business"
                          ? businessUser.name
                          : privateUser.name
                      }
                      onChange={handleInputChange}
                      className="booking-form-control"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="address">Street Address</label>
                    <input
                      type="text"
                      id="address"
                      name="address"
                      value={
                        userType === "business"
                          ? businessUser.address
                          : privateUser.address
                      }
                      onChange={handleInputChange}
                      className="booking-form-control"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="address2">Address 2 (optional)</label>
                    <input
                      type="text"
                      id="address2"
                      name="address2"
                      value={
                        userType === "business"
                          ? businessUser.address2
                          : privateUser.address2
                      }
                      onChange={handleInputChange}
                      className="booking-form-control"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="zipcode">Zip Code</label>
                    <input
                      type="text"
                      id="zipCode"
                      name="zipCode"
                      value={
                        userType === "business"
                          ? businessUser.zipCode
                          : privateUser.zipCode
                      }
                      onChange={handleInputChange}
                      className="booking-form-control"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="city">City</label>
                    <input
                      type="text"
                      id="city"
                      name="city"
                      value={
                        userType === "business"
                          ? businessUser.city
                          : privateUser.city
                      }
                      onChange={handleInputChange}
                      className="booking-form-control"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="country">Country</label>
                    <input
                      type="text"
                      id="country"
                      name="country"
                      value={
                        userType === "business"
                          ? businessUser.country
                          : privateUser.country
                      }
                      onChange={handleInputChange}
                      className="booking-form-control"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="totalCost">Total Cost</label>
                    <input
                      type="number"
                      id="totalCost"
                      name="totalCost"
                      value={totalCost}
                      readOnly
                      className="booking-form-control"
                    />
                  </div>
                </>
              )}
            </form>
            <button
              type="button"
              className="btn btn-secondary mb-3"
              onClick={addToCart}
            >
              Add to Cart
            </button>
            {shoppingCart.length > 0 && (
              <div className="shopping-cart">
                <h3>Shopping Cart</h3>
                <ul>
                  {shoppingCart.map((item, index) => (
                    <li key={index}>
                      {item.CustomerName} - {toDisplayDate(item.ArrivalDate)} to {toDisplayDate(item.DepartureDate)}
                      <button
                        type="button"
                        className="btn btn-danger ml-2"
                        onClick={() => handleRemoveFromCart(index)}
                      >
                        Remove
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {submitError && (
              <div className="alert alert-danger" role="alert">
                {submitError}
              </div>
            )}
            <button
              type="submit"
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting…' : 'Confirm Bookings'}
            </button>
            {availability && availability.length > 0 && (
              <div className="availability-results">
                <h3>Availability Results:</h3>
                <div className="availability-items">
                  {availability.map((item: any, index: number) => {
                    const isAvailable = item.availabilityStatus === "Available";
                    return (
                      <div key={index} className={`availability-item d-flex align-items-center gap-3 p-2 rounded mb-2 ${isAvailable ? 'availability-item--available' : 'availability-item--booked'}`}>
                        <input
                          type="checkbox"
                          name="availability"
                          className="availability-checkbox"
                          value={index}
                          checked={selectedAvailabilities.includes(index)}
                          onChange={() => handleCheckboxChange(index)}
                          disabled={!isAvailable}
                        />
                        <div className="availability-item__details">
                          {item.summary ? (
                            <span className="availability-item__summary">{item.summary}</span>
                          ) : (
                            <>
                              <span className="availability-item__price">
                                €{Number(getDisplayPrice(item.totalPrice)).toLocaleString()}
                              </span>
                              <span className="availability-item__per-night text-muted ms-1">
                                (€{Number(getDisplayPrice(item.pricePerNight)).toLocaleString()}/night)
                              </span>
                            </>
                          )}
                        </div>
                        <span className={`availability-status-dot ${isAvailable ? 'availability-status-dot--available' : 'availability-status-dot--booked'}`}>
                          {isAvailable ? 'Available' : 'Fully Booked'}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default NewBookingForm;
